import { Button, Card, Col, Flex, Form, Input, Row, Space } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { notifyError, notifySuccess } from '../../../store/utils';
import Zipcode from '../../../lib/Zipcode';
import { API } from '../../../api';
import BranchAreaSelect from '../../../lib/BranchAreaSelect';
import BranchTypeSelect from '../../../lib/BranchTypeSelect';

const BranchUpdate = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { branchId } = useParams();
  const [loading, setLoading] = useState(false);

  const onFinish = useCallback(
    async (values: any) => {
      try {
        setLoading(true);
        const streetNos = values.streetNo;
        const payload = {
          addressDetail: values.addressDetail,
          cd: values.cd,
          name: values.name,
          nameEn: values.nameEn,
          phone1: values.phone1,
          phone2: values.phone2,
          sms: values.sms,
          deliveryNo: values.deliveryNo || null,
          branchType: values.branchType,
          streetNo: streetNos.at(-1),
        };
        if (branchId) {
          await API.put({ apiVersion: 'api' })(`/branch/update/${branchId}`, payload);
          notifySuccess('Мэдээлэл амжилттай шинэчлэгдлээ');
          getBranch(branchId);
        } else {
          const {
            result: { data },
          } = await API.post({ apiVersion: 'api' })(`/branch/create`, payload);
          notifySuccess('Мэдээлэл амжилттай хадгаллаа');
          navigate(`/settings/branch/update/${data?.no}`);
        }
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [branchId]
  );

  const getBranch = useCallback(async (branchId: string) => {
    try {
      const {
        result: { data },
      } = await API.get({ apiVersion: 'api' })(`/branch/${branchId}`);
      const streets: any[] = [];
      if (data.street) {
        streets.push(data?.street?.province?.no);
        streets.push(data?.street?.district?.no);
        streets.push(data?.street?.no);
      }

      form.setFieldsValue({
        name: data.name,
        nameEn: data.nameEn,
        cd: data.cd,
        phone1: data.phone1,
        phone2: data.phone2,
        sms: data.sms,
        streetNo: streets,
        branchType: data.branchType?.code,
        deliveryNo: data?.branchArea ? data?.branchArea?.no : undefined,
        addressDetail: data.addressDetail,
      });
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  useEffect(() => {
    if (branchId) getBranch(branchId);
  }, [branchId]);

  return (
    <Card title="Салбар бүртгэх">
      <Row>
        <Col span={12} offset={6}>
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.Item
              name="name"
              label="Салбарын нэр"
              rules={[{ required: true, message: 'Салбарын нэр оруулна уу' }]}
            >
              <Input placeholder="Салбарын нэр оруулна уу" />
            </Form.Item>
            <Form.Item
              name="nameEn"
              label="Салбарын нэр (en)"
              rules={[{ required: true, message: 'Салбарын нэр (en) оруулна уу' }]}
            >
              <Input placeholder="Салбарын нэр (en) оруулна уу" />
            </Form.Item>
            <Form.Item
              name="cd"
              label="Салбарын код"
              rules={[{ required: true, message: 'Салбарын код оруулна уу' }]}
            >
              <Input disabled={!!branchId} placeholder="Салбарын код оруулна уу" />
            </Form.Item>
            <Form.Item
              name="phone1"
              label="Утас 1"
              rules={[{ required: true, message: 'Утас 1 оруулна уу' }]}
            >
              <Input placeholder="Утас 1 оруулна уу" />
            </Form.Item>
            <Form.Item
              name="phone2"
              label="Утас 2"
              rules={[{ required: true, message: 'Утас 2 оруулна уу' }]}
            >
              <Input placeholder="Утас 2 оруулна уу" />
            </Form.Item>
            <Form.Item name="sms" label="SMS мэдэгдэл хүлээн авах">
              <Input placeholder="Утас оруулна уу" />
            </Form.Item>
            <Form.Item name="deliveryNo" label="Хүргэлт">
              <BranchAreaSelect allowClear />
            </Form.Item>
            <Form.Item
              name="branchType"
              rules={[{ required: true, message: 'Салбарын төрөл сонгоно уу' }]}
              label="Салбарын төрөл"
            >
              <BranchTypeSelect allowClear />
            </Form.Item>
            <Form.Item
              name="streetNo"
              label="Салбарын хаяг"
              rules={[{ required: true, message: 'Салбарын хаяг оруулна уу' }]}
            >
              <Zipcode />
            </Form.Item>
            <Form.Item
              name="addressDetail"
              label="Дэлгэрэнгүй хаяг"
              rules={[{ required: true, message: 'Дэлгэрэнгүй хаяг оруулна уу' }]}
            >
              <Input.TextArea placeholder="Дэлгэрэнгүй хаяг оруулна уу" />
            </Form.Item>
            <Form.Item>
              <Flex justify="end" gap={24}>
                <Link to={`/settings/branch`}>
                  <Button htmlType="button">Буцах</Button>
                </Link>
                <Button loading={loading} type="primary" htmlType="submit">
                  Хадгалах
                </Button>
              </Flex>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Card>
  );
};

export default BranchUpdate;
